import { render } from "./EngineeringReviewRequirements.vue?vue&type=template&id=bfb361b2&scoped=true"
import script from "./EngineeringReviewRequirements.vue?vue&type=script&lang=js"
export * from "./EngineeringReviewRequirements.vue?vue&type=script&lang=js"

import "./EngineeringReviewRequirements.vue?vue&type=style&index=0&id=bfb361b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb361b2"]])

export default __exports__